export default __webpack_public_path__ + "static/media/iconsAddText.a8f7207a.svg";